import React from "react";
import styles from "./ResultsGrid.module.css";
import ResultCard from "../resultcard/ResultCard";
import { Reveal } from "../../../../../components/motion";

const ResultsGrid = ({ items = [], onPlay, title = "Últimos Resultados" }) => {
  return (
    <section className={styles.gridWrap}>
      <Reveal as="h3" className={styles.sectionTitle}>
        {title}
      </Reveal>
      <div className={styles.grid}>
        {items.map((it, i) => (
          // Retardo acotado: listas largas no acumulan esperas
          <Reveal key={it.id} delay={Math.min(i, 8) * 0.05}>
            <ResultCard
              lotteryName={it.lotteryName}
              date={it.date}
              numberDigits={it.numberDigits}
              seriesDigits={it.seriesDigits}
              logoUrl={it.logoUrl}
              color={it.color}
              onPlay={() => onPlay?.(it)}
            />
          </Reveal>
        ))}
      </div>
    </section>
  );
};

export default ResultsGrid;
